export default __webpack_public_path__ + "static/purple_arrow-3b7939e3bcc19a5d6bfbe8110bcff0ae.png";